import styled from 'styled-components';

export const RadioWindow = styled.span`
  position: relative;
  
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-right: 10px;
  
  border: 1px solid #e5e5e5;
  border-radius: 50%;
  
  transition: background-color 0.3s, border-color 0.3s;
  
  &::before {
    content: "";
    
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    
    display: none;    
    width: 12px;
    height: 12px;
    
    background-color: ${({ theme }) => theme.blue};
    border-radius: 50%;
  }
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: flex-start;
  
  font-size: 16px;
  line-height: 19px;
  
  cursor: pointer;
  
  &:hover ${RadioWindow} {
    border-color: ${({ theme }) => theme.blue};
  }
  
  span {
   display: flex;
   flex-direction: column;
  }
  
  p {
    margin: 0;
    margin-top: 5px;
    padding: 0;
    
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
`;

export const RadioContainer = styled.div`  
  color: ${({ theme }) => theme.black};
  user-select: none;
  
  input:checked ~ ${RadioLabel} ${RadioWindow} {
    border-color: ${({ theme }) => theme.blue};
    
    &::before {
      display: block;
    }
  }
`;
